import { createStore } from 'vuex'

//  Create a new store instance.
const store = createStore({
    state() {
        return {
            ready: false,

            // Touchkit sizing variables
            scale: 1,
            backgroundWidth: 0,
            appResolution: {},
            maximizedSizeAndOffset: {},

            // Touchkit Page data
            currentBackgroundComponents: [],

            // Touchkit navigation variables
            allowNavigation: true,
            isFullscreen: false,
            contentComponentOpen: false,
            videoTransitions: [],
            videoTransitionPlaying: false,
            queryParameters: null,

            restrictedAccess: [],

            // Touchkit Pagescroller
            draggingBackground: false,
            draggingBackgroundStartPositions: [],

            // Touchkit AudioManager
            muted: false,

            //DEIF Specific Variables
            showHotspotLabels: true
        }
    },
    mutations: {
        ready(state) {
            state.ready = true;
        },
        setScaleValue(state, value) {
            state.scale = value;
        },
        setAppResolutionValue(state, value) {
            state.appResolution = value;
        },
        setMaximizedSizeAndOffsetValue(state, value) {
            state.maximizedSizeAndOffset = value;
        },
        setCurrentBackgroundComponents(state, arr) {
            state.currentBackgroundComponents = arr
        },
        enableNavigation(state) {
            state.allowNavigation = true;
        },
        disableNavigation(state) {
            state.allowNavigation = false;
        },
        toggleFullscreen(state, bool) {
            state.isFullscreen = bool;
        },
        toggleContentComponentOpen(state, bool) {
            state.contentComponentOpen = bool;
        },

        // Video Transitions
        storeVideoTransitions(state) {
            if (!app.api.PageManager.getCustomComponentFromType("videoTransitions"))
                return

            let umbracoTransitions = app.api.PageManager.getCustomComponentFromType("videoTransitions").data.transitions;
            let transitions = [];

            transitions = umbracoTransitions.map((transition, i) => {
                transition.id = `transition_${i}`;
                transition.from = transition.from ? app.api.PageManager.getRouteFromID(transition.from) : null;
                transition.to = transition.to ? app.api.PageManager.getRouteFromID(transition.to) : null;
                return transition;
            })

            state.videoTransitions = transitions;
        },
        setIsVideoTransitionPlaying(state, bool) {
            return state.videoTransitionPlaying = bool
        },

        //Query Parameters
        setQueryParameters(state, value) {
            state.queryParameters = value
        },

        //Locked Hotspots
        restrictedAccessLogin(state, route) {
            if (!state.restrictedAccess.includes(route))
                state.restrictedAccess.push(route)

            app.api.LocalDataStore.set("restrictedAccess", state.restrictedAccess)
        },
        loadRestrictedAccess(state, accessList) {
            state.restrictedAccess = accessList;
        },

        // Touchkit Pagescroller
        setBackgroundWidth(state, value) {
            state.backgroundWidth = value;
        },
        toggleDraggingBackground(state, bool) {
            state.draggingBackground = bool;
        },
        saveScrollPosition(state, value) {
            const existingIndex = state.draggingBackgroundStartPositions.findIndex(s => s.route === value.route);

            // If the object already exists, replace it at the existing index
            if (existingIndex !== -1) {
                state.draggingBackgroundStartPositions.splice(existingIndex, 1, value);

                // If it doesn't exist, push the new object
            } else {
                state.draggingBackgroundStartPositions.push(value);
            }
        },

        // Touchkit AudioManager
        toggleMute(state) {
            state.muted = !state.muted;

            if (state.muted) {
                app.api.AudioManager.mute()
            } else {
                app.api.AudioManager.unmute()
            }
        },
        mute(state) {
            state.muted = true;
            app.api.AudioManager.mute()
        },
        unmute(state) {
            state.muted = false;
            app.api.AudioManager.unmute()
        },
        toggleShowHotspotLabels(state) {
            state.showHotspotLabels = !state.showHotspotLabels
        } 
    },
    getters: {
        ready(state) {
            return state.ready;
        },
        getScaleValue(state) {
            return state.scale;
        },
        getAppResolutionValue(state) {
            return state.appResolution;
        },
        getMaximizedSizeAndOffsetValue(state) {
            return state.maximizedSizeAndOffset;
        },
        getCurrentBackgroundComponents(state) {
            return state.currentBackgroundComponents
        },
        canNavigate(state) {
            return state.allowNavigation;
        },
        isFullscreen(state) {
            return state.isFullscreen;
        },
        getContentComponentOpen(state) {
            return state.contentComponentOpen;
        },

        // Video Transitions
        getVideoTransitions(state) {
            return state.videoTransitions;
        },
        getIsVideoTransitionPlaying(state) {
            return state.videoTransitionPlaying
        },

        //Query Parameters
        getQueryParameters(state) {
            return state.queryParameters
        },

        //Locked Hotspots
        getRestrictedAccessLogins(state) {
            return state.restrictedAccess
        },

        // Touchkit Pagescroller
        getBackgroundWidth(state) {
            return state.backgroundWidth;
        },
        isBackgroundDragged(state) {
            return state.draggingBackground;
        },
        getSavedScrollPosition: (state) => (route) => {
            return state.draggingBackgroundStartPositions.find(s => s.route === route);
        },

        // Touchkit AudioManager
        getIsMuted(state) {
            return state.muted
        },
        isHotspotLabelsVisible(state) {
            return state.showHotspotLabels;
        }
    },
    actions: {
        ready(context) {
            context.commit('ready')
        },
        loadRestrictedAccess({ commit }) {
            const accessList = app.api.LocalDataStore.get("restrictedAccess");
            if (accessList) {
                commit('loadRestrictedAccess', accessList);
            }
        }
    }
})

export default store;
